import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { initOnPageUsers, populateFriends } from './actionCreators';
import { handleActions } from 'redux-actions';
const handler = handleActions({
    [initOnPageUsers.toString()]: (state, { payload })=>{
        return _object_spread_props(_object_spread({}, state), {
            usersOnPage: payload && payload.users || false
        });
    },
    [populateFriends.toString()]: (state, { payload })=>{
        if (!payload) {
            return state;
        }
        const { friends, alpha, page } = payload;
        return _object_spread_props(_object_spread({}, state), {
            friends: _object_spread_props(_object_spread({}, state.friends), {
                [alpha]: _object_spread({}, state.friends[alpha], friends)
            }),
            friendPages: _object_spread_props(_object_spread({}, state.friendPages), {
                [alpha]: page
            })
        });
    }
}, {
    friendPages: {},
    friends: {}
});
export default {
    [reduxKey]: handler
};

//# sourceMappingURL=reducers.js.map